export default __webpack_public_path__ + "static/media/mar_drone2.55046852.jpg";